import { CompactUserResponse, UserId, UserResponse } from '../account';
import { BaseResponse, ExtendedFile } from '../common';
import { CompanyId } from '../companies';
import { GraphConditionId, GraphConditionResponse } from '../graph_condition';
import { TaskStatusResponse } from '../task_status';

export type SectionId = string;
export type TaskId = string;
export type TaskShareId = string;
export type TaskCompletedId = string;
export type CommentId = string;

export interface AccountResponse {
  companyId: CompanyId;
  title: string;
  appId: string;
}

export interface BattlePlanSectionResponse extends BaseResponse {
  id: SectionId;
  title: string;
  assignedTo: string;
  type: string;
  createdAt: number;
  user?: UserResponse;
  author?: UserResponse;
  isAuthor: boolean;
  parentId: string;
  canManage: boolean;
  companyId: CompanyId;
  menuOrder: number;
  tasks: BattlePlanSectionTaskResponse[];
}

export enum TaskPriority {
  none = 'none',
  urgent = 'urgent',
  high = 'high',
  normal = 'normal',
  low = 'low',
}

export enum BattlePlanTaskRecurring {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export interface BattlePlanSectionTaskResponse extends BaseResponse {
  id: TaskId;
  sectionId: SectionId;
  title: string;
  createdBy: string;
  createdUser: CompactUserResponse;
  menuOrder: string;
  dueDate: number;
  assignees: UserId[];
  isTaskCompleted: boolean;
  completedAt: any;
  stepCompletedData: any;
  createdAt: number;
  priority: TaskPriority;
  type: string;
  files: ExtendedFile[];
  status: TaskStatusResponse;
  description: string;
  recurring: BattlePlanTaskRecurring;
  conditionId: GraphConditionId;
  lineNumber: number;
  condition: GraphConditionResponse;
}

export interface BattlePlanSectionSortingResponse extends BaseResponse {
  id: SectionId;
  menuOrder: number;
  steps: BattlePlanSectionTaskSortResponse[];
}

export interface BattlePlanSectionTaskSortResponse extends BaseResponse {
  id: SectionId;
  menuOrder: number;
}

export interface BattlePlanSectionTaskShareResponse extends BaseResponse {
  id: TaskShareId;
  taskId: TaskId;
  type: string;
  userId: UserId;
  fullName?: string;
}

export interface BattlePlanSectionTaskCompletedResponse extends BaseResponse {
  id: TaskCompletedId;
  taskId: TaskId;
  status: string;
  completedDate: number;
  completedBy: string;
  completedByUser: UserResponse;
}

export interface BattlePlanTaskCommentResponse extends BaseResponse {
  id: CommentId;
  taskId: TaskId;
  comment: string;
  createdAt: number;
  userId: string;
  user: UserResponse;
  isOwner: boolean;
}

export interface ControlBoardItem {
  id: string;
  menuOrder: number;
  title: string;
  cards: BattlePlanSectionTaskResponse[];
}

export interface BoardType {
  columns: ControlBoardItem[];
}

export type CompactBattlePlanSectionResponse = Pick<BattlePlanSectionResponse, 'id' | 'title'>;
